var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_512_7560)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.5 12H7.5V13.5H16.5V12Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.5 7.5H7.5V9H16.5V7.5Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 22.5L7.36815 20.0303C6.04759 19.3279 4.94325 18.279 4.17369 16.9964C3.40412 15.7138 2.99838 14.2458 3 12.75V3C3.00044 2.60231 3.15862 2.22103 3.43983 1.93982C3.72104 1.65861 4.10231 1.50044 4.5 1.5H19.5C19.8977 1.50044 20.279 1.65861 20.5602 1.93982C20.8414 2.22103 20.9996 2.60231 21 3V12.75C21.0016 14.2458 20.5958 15.7137 19.8263 16.9963C19.0567 18.2789 17.9524 19.3277 16.6319 20.0302L12 22.5ZM4.5 3V12.75C4.49871 13.9739 4.83072 15.175 5.46041 16.2244C6.0901 17.2738 6.9937 18.132 8.0742 18.7067L12 20.8L15.9258 18.7067C17.0063 18.132 17.9099 17.2738 18.5396 16.2244C19.1693 15.175 19.5013 13.9739 19.5 12.75V3H4.5Z",
  fill: "currentColor"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_512_7560"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
})));

var SvgCompanyIcon = function SvgCompanyIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCompanyIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CompanyIcon.4423c1c9.svg";
export { ForwardRef as ReactComponent };